/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 0
// module chunks = 0